import { ref } from 'vue'

export const useCategoryFilter = () => {
  const subCategoryRef = ref(null)
  const title = ref('') // current main category
  const current = ref('') // current main category
  const currentSub = ref('') // current sub category

  /**
   * 현재 active 된 카테고리 정보를 반환
   * @param category
   * @param main
   * @param sub
   * @returns {*}
   */
  const getCurrentCategory = (category, main, sub) => {
    current.value = category.categoryList?.find((item) => item.code === main)
    currentSub.value = current.value?.subList?.find((item) => item.code === sub)

    return current.value
  }

  /**
   * 현재 active 된
   * 메인 카테고리의 타이틀,
   * 서브 카테고리의 타이틀을 반환
   */
  const getCategoryTitles = () => {
    const mainCategoryTitle = getTitle(current.value)
    const subCategoryTitle = getTitle(currentSub.value)

    return { mainCategoryTitle, subCategoryTitle }
  }

  /**
   * category list 의 category 의 text (타이틀)를 반환
   * @param category
   * @returns {*|string}
   */
  const getTitle = (category) => {
    const [element] = category?.elementList ?? []
    return element?.property?.text ?? ''
  }

  /**
   * 현재 active 된 카테고리의 서브 카테고리 리스트를 반환
   * @returns {{adult: string, title, value}[]}
   */
  const getSubCategoryList = () => {
    const subList = current.value?.subList ?? []
    return subList.map((sub) => {
      return {
        adult: 'n',
        title: getTitle(sub),
        value: sub?.code ?? '',
      }
    })
  }

  const appendMainHome = (arr) => {
    arr?.unshift({
      adult: 'n',
      title: `${getTitle(current.value)} 홈 `,
      value: current.value?.code ?? '',
    })
  }

  const setCategoryFilter = ({ category = '', main = '', sub = '' }) => {
    getCurrentCategory(category, main, sub)

    const { mainCategoryTitle, subCategoryTitle } = getCategoryTitles()
    title.value = mainCategoryTitle

    const subCategoryList = getSubCategoryList()
    // 서브카테고리리스트의 첫번째로 메인카테고리로 이동하는 항목을 추가
    appendMainHome(subCategoryList)

    subCategoryRef.value = {
      _default: subCategoryTitle,
      itemList: subCategoryList,
    }
  }

  return {
    title,
    subCategoryRef,
    getTitle,
    appendMainHome,
    getCategoryTitles,
    getSubCategoryList,
    setCategoryFilter,
  }
}
